//记得在 src\components\lang\zhLoad.js 里面添加对象
const client= {
  clientId:"ClientId",
  clientName: 'ClientName',
  resourceIds:'ResourceIds',
  clientSecret:'ClientSecret',
  accessTokenValidity:'TokenValidity(second)',
  refreshTokenValidity:'RefreshToken(second)',
  scope:'Scope',
  authorities:'ApiAuthorities',
  remark:'Remark',
  addClient:'AddClient',
  editClient:'EditClient',
  editSecret:'EditSecret',
  resetSecret:'ResetSecret',
  oldClientSecret:'CurrentSecret',
  newClientSecret:'NewSecret',
  rewriteSecret:'EnterAgain',
  exportData:'ExportData',
  initPwd:'UserInitPwd',
  init_client_info:'InitClientRedis',
  init_user_info:'InitUserRedis',
  init_menu_info:'InitMenuRedis',
  init_role_info:'InitRoleRedis',
  init_permission_info:'InitPermissionRedis',
  init_page_op_info:'InitButtonRedis',
  msg:{
    clientName:'Please input the clientName',
    clientId:"Please input the clientId",
    resourceIds:'Please input the resourceIds',
    clientSecret:'Please input the clientSecret',
    accessTokenValidity:'Please input the accessTokenValidity',
    refreshTokenValidity:'Please input the refreshTokenValidity',
    scope:'Please input the scope',
    currentPwd:'Please input the current secret',
    newPwd:'Please input the new secret',
    enterAgain:'Please enter again the new secret',
    initPwd:'Please input the user init password'
  }
};
export default client



// WEBPACK FOOTER //
// ./src/page/auth/client/lang/client.en.js